import { Component, createContext } from 'react'
import { withRouter } from 'next/router'

//* Helpers
import { ThemeProvider } from 'styled-components'
import themes from 'styles/theme'
import HelperClass from 'styles/helperClass'
import Variables from 'styles/variables'
import Typography from 'styles/typography'

//* Style
import FormStyle from 'styles/pages/FormStyle'

const UIContext = createContext(null)

class UIProvider extends Component {
    //! States
    state = {
        winWidth: 1920,
        winHeight: 1080,
        screenSizes: {},
        highComponent: null,
        popupIsOpen: false,
        popupComponent: null,
        popupProps: {},
        isBurgerMenuOpen: false,
        isGatesActive: true,
        eventOrNews: null,
    }

    //! Methods
    methods = {
        addHighComponent: this.addHighComponent.bind(this),
        removeHighComponent: this.removeHighComponent.bind(this),
        disableDomScroll: this.disableDomScroll.bind(this),
        enableDomScroll: this.enableDomScroll.bind(this),
        openPopup: this.openPopup.bind(this),
        closePopup: this.closePopup.bind(this),
        togglePopup: this.togglePopup.bind(this),
        toggleBurgerMenu: this.toggleBurgerMenu.bind(this),
        closeBurgerMenu: this.closeBurgerMenu.bind(this),
        setIsGatesActive: this.setIsGatesActive.bind(this),
        setEventOrNews: this.setEventOrNews.bind(this),
    }

    //! get event or news
    setEventOrNews(type) {
        this.setState({ eventOrNews: type })
    }

    setIsGatesActive(isActive) {
        this.setState({ isGatesActive: isActive })
    }

    //! Screen Resize
    resizeTimeout
    screenResize = () => {
        this.resizeTimeout && clearTimeout(this.resizeTimeout)

        this.resizeTimeout = setTimeout(() => {
            this.setState({
                winWidth: window.innerWidth,
                winHeight: window.innerHeight,
            })
        }, 500)
    }

    //! Get Media Screen Sizes from Css Variables
    getScreenSizes() {
        const root = getComputedStyle(document.documentElement)

        const screenSizes = {
            desktopSizeXL: parseInt(root.getPropertyValue('--desktopSizeXL')),
            desktopSizeL: parseInt(root.getPropertyValue('--desktopSizeL')),
            desktopSizeM: parseInt(root.getPropertyValue('--desktopSizeM')),
            desktopSizeS: parseInt(root.getPropertyValue('--desktopSizeS')),
            desktopSizeXS: parseInt(root.getPropertyValue('--desktopSizeXS')),
            tabletSize: parseInt(root.getPropertyValue('--tabletSize')),
            tabletSizeS: parseInt(root.getPropertyValue('--tabletSizeS')),
            mobileSize: parseInt(root.getPropertyValue('--mobileSize')),
        }

        this.setState({ screenSizes })
    }

    //! Toggle Popup
    togglePopup() {
        this.setState({
            popupIsOpen: !this.state.popupIsOpen,
        })
    }

    toggleBurgerMenu() {
        this.setState({ isBurgerMenuOpen: !this.state.isBurgerMenuOpen })
    }

    closeBurgerMenu() {
        this.state.isBurgerMenuOpen && this.setState({ isBurgerMenuOpen: false })
    }

    //! Open Popup
    openPopup(popupComponent = null, popupProps = {}) {
        // if (typeof popupComponent === 'string' && this.popup.includes(popupComponent) && this.props.router.query?.c !== popupComponent) {
        // 	const { pathname, query } = routerToPathAndQuery(this.props.router, 'c', popupComponent)
        // 	this.props.router.push({ pathname, query }, undefined, { shallow: true })
        // }

        // this.disableDomScroll()

        this.setState({
            popupIsOpen: true,
            popupComponent,
            popupProps,
        })
    }

    //! Close Popup
    closePopup(scroll = false) {
        // const { pathname, query } = routerToPathAndQuery(this.props.router, 'c')
        // this.props.router.push({ pathname, query }, undefined, { scroll: false })

        this.enableDomScroll()

        this.setState({
            popupIsOpen: false,
            popupComponent: null,
        })
    }

    //! Disable DOM Scroll
    disableDomScroll() {
        //? document.querySelector('html').classList.add('hide-scroll')

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

        //? if any scroll is attempted, set this to the previous value
        window.onscroll = function (e) {
            e.preventDefault()
            window.scrollTo(scrollLeft, scrollTop)
        }
    }

    //! Enable DOM Scroll
    enableDomScroll() {
        //? document.querySelector('html').classList.remove('hide-scroll');

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft

        window.onscroll = function () { }
        window.scrollTo(scrollLeft, scrollTop)
    }

    //! Component Did Mount
    componentDidMount() {
        this.setState({
            ...this.state,
        })

        window.addEventListener('resize', this.screenResize)
        this.getScreenSizes()
        this.screenResize()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.router.asPath !== this.props.router.asPath) {
            this.setState({
                ...this.state,
            })
        }
    }

    //! Component Will Unmount
    componentWillUnmount() {
        window.addEventListener('resize', this.screenResize)
        document.removeEventListener('keydown', this.escKeydown, false)
    }

    //! Add High Component
    addHighComponent(component = null) {
        this.setState({
            highComponent: component,
        })
    }

    updateHighComponentProps(props) {
        const Comp = this.state.component
        Comp.props = props

        this.setState({
            highComponent: Comp,
        })
    }

    //! Remove High Component
    removeHighComponent() {
        this.setState({
            highComponent: null,
        })
    }

    render() {
        return (
            <UIContext.Provider value={{ ...this.state, ...this.methods }}>
                <ThemeProvider theme={themes}>
                    <Variables />
                    <Typography
                        isGatesActive={this.state.isGatesActive}
                        popupIsOpen={this.state.popupIsOpen}
                        isBurgerMenuOpen={this.state.isBurgerMenuOpen}
                    />
                    <HelperClass />
                    <FormStyle />

                    {this.props.children}
                </ThemeProvider>
            </UIContext.Provider>
        )
    }
}

export default withRouter(UIProvider)
export const UIConsumer = UIContext.Consumer
